import React from "react";

export type ErrorContextType = { statusCode: number; setStatusCode: (code: number) => void };

export const ErrorContext = React.createContext<ErrorContextType>({
    statusCode: 200,
    setStatusCode: (code: number) => {},
});
